module.exports = __webpack_public_path__ + "static/media/support-small.961c8f56.webp";